// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".question-icon[data-v-f74d066e]{vertical-align:top}.close-btn[data-v-f74d066e]{border-radius:50%!important;position:absolute;right:8px;top:8px;cursor:pointer}.wallet-icon[data-v-f74d066e]{width:100%}", ""]);
// Exports
module.exports = exports;
